import { render } from "./PicnicPackageAmenity.vue?vue&type=template&id=24bd3c74&scoped=true"
import script from "./PicnicPackageAmenity.vue?vue&type=script&lang=js"
export * from "./PicnicPackageAmenity.vue?vue&type=script&lang=js"

import "./PicnicPackageAmenity.vue?vue&type=style&index=0&id=24bd3c74&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bd3c74"]])

export default __exports__